import { TemplateType } from '../config/template';

export const getSmsTemplates = (currentDocType, selectedPrintReport) => {
  const templates = (currentDocType?.template ?? []).filter((template) =>
    template?.templateType === TemplateType.SMS &&
    (template.documentTypeId == null ||
      Number(template.documentTypeId) === Number(currentDocType?.documentTypeId))
  );
  const selectedFormId = selectedPrintReport?.formid ?? null;
  const matching = templates.filter((template) => Number(template.formId) === Number(selectedFormId));
  if (matching.length) return matching;
  const independent = templates.filter((template) => template.formId == null);
  return independent.length ? independent : templates;
};

export const createSmsInitialState = (templates, documentValues, selectedCompany) => {
  const contacts = selectedCompany?.companyContact ?? [];
  const contact = contacts.find((item) => Number(item.id) === Number(documentValues?.companyContactId)) ??
    contacts.find((item) => item.default) ?? contacts[0];
  const template = templates.find((item) => item.languageCode && item.languageCode === documentValues?.langCode) ??
    templates.find((item) => !item.languageCode) ?? templates[0];

  return {
    selectedTemplateId: template?.id ?? '',
    to: contact?.phoneNumber || contact?.phoneNumber2 || selectedCompany?.phoneNumber || '',
    body: template?.body ?? '',
  };
};

export const normalizeSmsRecipients = (value) => [...new Set(
  String(value ?? '').split(/[;,\n]/).map((item) => item.replace(/[\s()-]/g, '')).filter(Boolean)
)];

export const isSmsPhoneNumber = (value) => /^\+?[0-9]{7,15}$/.test(value);
